import Swiper from "swiper";

export default function () {

    const breakpoint = window.matchMedia( '(min-width:768px)' );
    let mySwiper;

    const breakpointChecker = function() {
        if ( breakpoint.matches === true ) {
            if ( mySwiper !== undefined ) {
                $(".clean-slider-mobile").each(function(){
                    this.swiper.destroy(true, true);
                });
            }
            return;
        } else if ( breakpoint.matches === false ) {
            return enableSwiper();
        }
    };

    const enableSwiper = function() {
        mySwiper = new Swiper(".clean-slider-mobile", {
            slidesPerView: 1.2,
            spaceBetween: 30,
            centeredSlides: true,
            loop: true,
            allowTouchMove: true,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                    centeredSlides: true,
                    allowTouchMove: false,
                }
            }
        });
    };

    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
}


